var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", {}, [
    _vm.$scopedSlots.image
      ? _c("div", { staticClass: "grid gap-1" }, [
          _c(
            "div",
            { staticClass: "w-4/4 pt-4 h-40 mr-0" },
            [_vm._t("image")],
            2
          ),
          _c(
            "div",
            {
              staticClass:
                "flex items-center font-normal text-base justify-center flex-col",
            },
            [
              _c(
                "p",
                {
                  staticClass:
                    "flex flex-col font-normal text-gray-new justify-center items-center",
                },
                [
                  _vm._v(_vm._s(_vm.description) + " "),
                  _c("br"),
                  _vm._v(_vm._s(_vm.desc) + " "),
                  _c("br"),
                ]
              ),
              _vm.isAccessGranted
                ? _c("UiButton", {
                    staticClass: "mt-2",
                    attrs: {
                      buttonText: "Add resource",
                      label: "add black",
                      buttonClass: "customAdd",
                    },
                    on: { click: _vm.showModal, open: _vm.showModal },
                  })
                : _vm._e(),
              _vm.modalShown
                ? _c("AddResourceInformationModal", {
                    attrs: {
                      currentUserId: _vm.currentUserId,
                      contractorId: _vm.contractorId,
                      contractorUserId: _vm.contractorId,
                      title: "Resource Information",
                    },
                    on: {
                      close: _vm.closeModal,
                      open: _vm.showModal,
                      refresh: _vm.refreshPage,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }